export default function About() {
  return (
    <section id="about" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-shrink-0 w-full lg:w-96">
            <div className="aspect-[4/3] rounded-2xl overflow-hidden bg-background-200">
              <img
                src="https://readdy.ai/api/search-image?query=Abstract%20brand%20identity%20visual%20for%20a%20premium%20video%20streaming%20platform%2C%20warm%20coral%20and%20golden%20gradients%20forming%20an%20elegant%20emblem%20like%20composition%2C%20stylized%20play%20button%20and%20film%20elements%20integrated%20into%20geometric%20design%2C%20dark%20sophisticated%20background%2C%20modern%20corporate%20brand%20art%20style&width=600&height=450&seq=about-91md-01&orientation=landscape"
                alt="91麻豆免费视频网站品牌介绍"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
          <div className="flex-1 text-center lg:text-left">
            <span className="inline-block px-3 py-1 bg-secondary-100 text-secondary-700 text-xs font-medium rounded-full mb-4 whitespace-nowrap">
              关于我们
            </span>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-5">
              关于91麻豆免费视频网站
            </h2>
            <div className="space-y-4">
              <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
                91麻豆免费视频网站是专注于91高清视频在线观看的专业视频平台，致力于为广大用户提供高品质、流畅不卡顿的超清视频在线观看体验。平台汇聚海量91国产高清视频与高清影视在线资源，每日更新精彩内容，是您休闲娱乐的首选视频网站。
              </p>
              <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
                我们始终坚持以用户体验为核心，采用先进的流媒体传输技术与智能推荐算法，确保每一位用户都能轻松找到心仪内容，享受极致的91高清视频在线观看之旅。从内容筛选到播放优化，每一个环节都经过精心打磨，只为呈现最好的观影体验。
              </p>
            </div>
            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 mt-6">
              <div className="flex items-center gap-2 text-sm text-foreground-500">
                <i className="ri-check-double-line text-primary-500"></i>
                <span>20000+ 精选资源</span>
              </div>
              <div className="flex items-center gap-2 text-sm text-foreground-500">
                <i className="ri-check-double-line text-primary-500"></i>
                <span>每日持续更新</span>
              </div>
              <div className="flex items-center gap-2 text-sm text-foreground-500">
                <i className="ri-check-double-line text-primary-500"></i>
                <span>1080P 超清画质</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}